import {baseUrl, khglUrl, dicUrl} from '@/config/env'
import request from '@/router/axios'
import {userInfo, tableData} from '@/mock/user'
import {menu, menuAll} from '@/mock/menu'

export const loginByUsername = (username, password, code, randomStr) => {
  var grant_type = 'password'
  var scope = 'server'
  return request({
    url: '/auth/oauth/token',
    headers: {
      'Authorization': 'Basic ZWlzOmVpcw=='
    },
    method: 'post',
    params: {username, password, randomStr, code, grant_type, scope}
  })
}

export const LoginBySSO = (userId,timestamp,sign,clientId) => {
  var grant_type = 'sso'
  var username="3010;"+userId
  return request({
    url: '/auth/oauth/token',
    headers: {
      'Authorization': 'Basic dHBwOnRwcA=='
    },
    method: 'post',
    params: {username,userId, grant_type,timestamp,sign,clientId}
  })

}
export const LoginByWechatSSO = (code) => {
  var grant_type = 'wechat_sso'
  var scope = 'server'
  var companyId = '3010'
  return request({
    url: '/auth/oauth/token',
    headers: {
      'Authorization': 'Basic ZWlzOmVpcw=='
    },
    method: 'post',
    params: {code,grant_type,scope,companyId}
  })
}
export const loginByUsernameNoCode = (username, password) => {
  var grant_type = 'password'
  var scope = 'server'
  var client = 'app'
  return request({
    url: '/auth/oauth/token',
    headers: {
      'Authorization': 'Basic ZWlzOmVpcw=='
    },
    method: 'post',
    params: {username, password, grant_type, scope, client}
  })
}

export function mobileLogin(mobile, code) {
  var grant_type = 'mobile'
  var scope = 'server'
  return request({
    url: '/auth/mobile/token',
    headers: {
      'Authorization': 'Basic ZWlzOmVpcw=='
    },
    method: 'post',
    params: {mobile, code, grant_type, scope}
  })
}

export const getUserInfo = () => {
  return request({
    url: '/admin/user/info',
    method: 'get'
  })
}

export const logout = (accesstoken, refreshToken) => {
  return request({
    url: '/auth/authentication/removeToken',
    method: 'post',
    params: {accesstoken, refreshToken}
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js